// extracted by mini-css-extract-plugin
export var headlineHeaderSeparator = "headline__header-separator_IMZGFSenxcQiAXpZXdul";
export var headlineSubHeader = "headline__sub-header_jLE3yGh1rAaCEZKNoL93";
export var headlineTitle = "headline__title_BWp5MeORGGTdqvodCb9t";